// src/axiosConfig.js
import axios from 'axios';

// Create an Axios instance with default configurations
const axiosInstance = axios.create({
  //baseURL: 'http://localhost:8000/api',  // Set your base URL here
  baseURL: "https://present-bot.com/api",
  //timeout: 100,  // Optional: Set a timeout for requests (10 seconds)
  headers: {
    'Content-Type': 'application/json',  // You can set default headers here
  },
});

export default axiosInstance;